<template>
  <!-- 用于html2canva绘画分享的页面 -->
  <div :class="['shareWrapper', showPicTop?'showPicTop':'']" ref="shareImgWrapper" id="shareImgWrapper">
    <!-- 诗歌分享 -->
    <!-- {{content.view}} -->
    <PoetryShare v-if="shareId == 39" :data="shareShowData"></PoetryShare>
 
    <img id="showimg" src="" class="showimg">
   <!-- <div class="test" @click="onClick" >关闭</div> -->
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { PoetryShare } from "./share/index";
export default {
  name: "ShareWrapper",
  computed: {
    ...mapState(["shareId", "shareShowData","showPicTop"]),
  },
  components: {
    PoetryShare,
  },
  methods: {
        ...mapMutations(["setShowPicTop"]),
    onClick:function(){
         this.setShowPicTop(false)
    }
  },
};
</script>
<style lang="less" scoped>
.shareWrapper {

  opacity: 0;
      // width: 10rem;
      //  height: 17.786667rem;

  left: 0;
  display: none;
      position: absolute;
  z-index: 0;
}
.showPicTop{
  display: block;
  opacity: 1;
      width: 10rem;
      //  height: 17.786667rem;
    left: 0;
    position: absolute;
    // top: 0;
    z-index: 1;
    // 零时测试 
    //     z-index: 33;
    // top: 0;
}
// .showimg{
//   opacity: 0;
//   display: none;
// }
.test{
  position: absolute;
 
  left: 0;
  background-color: #fff;
  color: red;
}
</style>
